var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('v-chart',{ref:"chart",staticClass:"chart",attrs:{"autoresize":"","option":_vm.option,"theme":_vm.theme}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }